import { SESSION_STORAGE_BIN_KEY } from "./getStoredBinsFromSession";

export function setStoredBinsToSession(bins: Record<string, unknown>) {
  sessionStorage.setItem(SESSION_STORAGE_BIN_KEY, JSON.stringify(bins));
}
